export const createIsSecureContext = (window) => (window !== null && window.isSecureContext);
//# sourceMappingURL=/build/es2018/factories/is-secure-context.js.map